import React from 'react';
import { Award, ShieldCheck, Headphones, Lightbulb } from 'lucide-react';
import { aboutSection } from '../mockData';

const About = () => {
  const getIcon = (iconName) => {
    const icons = {
      award: Award,
      'shield-check': ShieldCheck,
      headphones: Headphones,
      lightbulb: Lightbulb
    };
    const Icon = icons[iconName];
    return Icon ? <Icon size={32} /> : null;
  };

  return (
    <section id="somos" className="section about-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{aboutSection.title}</h2>
          <p className="section-description">{aboutSection.description}</p>
        </div>

        <div className="values-grid">
          {aboutSection.values.map((value, index) => (
            <div key={index} className="value-card">
              <div className="value-icon">
                {getIcon(value.icon)}
              </div>
              <h3 className="value-title">{value.title}</h3>
              <p className="value-description">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
